import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import HideOnScroll from '../scrolls/HideOnScroll';
import useEnvironment from '../../hooks/useEnvironment';
import { TOOLBAR_CLASS_NAME } from '../../theme/constants/toolbar';

const getStyles = (theme) => ({
  navbar: {
    minHeight: theme.components.MuiToolbar.navbarHeight,
    justifyContent: 'center',
    bgcolor: 'common.white',
  },
  gradientAnimation: {
    '@keyframes rainbow-background': {
      '0%': { backgroundPosition: '0 0' },
      '100%': { backgroundPosition: '200% 0' },
    },
  },
  localhostGradient: {
    background: `linear-gradient(
      to right,
      ${theme.palette.transition.A100}, 
      ${theme.palette.transition.A200},
      ${theme.palette.transition.A300},
      ${theme.palette.transition.A400},
      ${theme.palette.transition.A500},
      ${theme.palette.transition.A600},
      ${theme.palette.transition.A700}
    )`,
    backgroundSize: '200% 100%',
    animation: 'rainbow-background 8s linear infinite',
    [`& .${TOOLBAR_CLASS_NAME}`]: {
      backgroundColor: 'transparent !important',
    },
  },
});

const FingoNavbar = ({ children, useGradient }) => {
  const { isLocalhost, name, isStaging } = useEnvironment();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <HideOnScroll>
      <AppBar
        elevation={0}
        position="sticky"
        sx={{
          ...styles.navbar,
          ...styles.gradientAnimation,
          ...((isLocalhost || isStaging) && useGradient && styles.localhostGradient),
        }}
      >
        <Toolbar className={TOOLBAR_CLASS_NAME}>
          {(isLocalhost || isStaging) && useGradient && (
            <Typography style={{ marginRight: 16, color: 'white', fontWeight: 'bold' }}>
              {name?.toUpperCase()}
            </Typography>
          )}
          {children}
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
};

FingoNavbar.propTypes = {
  children: PropTypes.node.isRequired,
  useGradient: PropTypes.bool,
};
FingoNavbar.defaultProps = {
  useGradient: true,
};

export default FingoNavbar;
